import PropTypes from 'prop-types';
import styles from './TagCloud.module.scss';

const TagCloud = ({ tags }) => {
  const getRandomSize = () => {
    const sizes = ['small', 'medium', 'large'];
    return sizes[Math.floor(Math.random() * sizes.length)];
  };

  const getRandomColor = () => {
    const colors = [
      '#0a192f', // ciemnoniebieski
      '#1a365d', // granatowy
      '#2b4c76', // niebieski
      '#466b95', // jasnoniebieski
      '#666666', // ciemnoszary
      '#888888', // szary
      '#aaaaaa', // jasnoszary
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  return (
    <div className={styles.tagCloud}>
      {tags.map((tag, index) => (
        <span
          key={index}
          className={`${styles.tag} ${styles[`tag_${getRandomSize()}`]}`}
          style={{ color: getRandomColor() }}
        >
          {tag}
        </span>
      ))}
    </div>
  );
};

TagCloud.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default TagCloud; 